const usePluralize = (count, noun, suffix = "s") => {
  if (noun === "Person" && count !== 1) {
    return "People";
  }
  return count === 1 ? noun : `${noun}${suffix}`;
};
export default usePluralize;
